export function getLogoDirByHost() {
    const host = window.location.hostname;

    const adsURL = `adsgroup.${process.env.VUE_APP_MANAGER_URL}`;

    if(host === adsURL) {
        return "/assets/images/ads/";
    } else {
        return "/assets/images/";
    }
}